import { CustomEventWithDetail } from 'rune-ts';
import { type PopupStoreItemCardType } from '../type';

export class OpenSubscribeModalEvent extends CustomEventWithDetail<{ item: PopupStoreItemCardType }> {}

export class ListScrollEvent extends CustomEventWithDetail<{ list_el: EventTarget; scroll_y: number }> {}
